import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { AccountRegistrationService } from '../../services/account-registration.service'

@Component({
  selector: 'app-account-selection',
  templateUrl: './account-selection.component.html',
  styleUrls: ['./account-selection.component.scss'],
})
export class AccountSelectionComponent {
  adminFeatures: string[] = ['組織図の作成や組織の編集', '企業情報の編集', 'アプリの購入']

  userFeatures: string[] = ['アプリストアの閲覧', 'ワークフローの申請']

  constructor(
    private router: Router,
    private accountRegistrationService: AccountRegistrationService,
  ) {}

  onAdminRegister(): void {
    this.accountRegistrationService.setAccountType('admin')
    // 管理者登録画面へ遷移
    this.router.navigate(['/registration'])
  }

  onUserRegister(): void {
    this.accountRegistrationService.setAccountType('user')

    // 一般社員登録画面へ遷移
    this.router.navigate(['/registration'])
  }
}
